import React, { useState } from "react";
import { MENUS } from "../../../../../utils/ui.constants";
import SidebarList from "./SidebarList";
import { Box, Divider } from "@mui/material";
import { useLocation } from "react-router-dom";
import { isArray } from "lodash";

function SidebarWide() {
  const location = useLocation();
  const [indexExpand, setIndexExpand] = useState<number>(() => {
    let index = 0;
    for (let i = 0; i < MENUS.length; i++) {
      const menu = MENUS[i];
      if (isArray(menu?.items) && menu?.items?.length > 0) {
        const currentMenu = menu.items.find(
          (item) => item.path === location.pathname
        );
        if (!!currentMenu) {
          index = i;
          break;
        }
      } else {
        index = -1;
      }
    }
    return index;
  });

  return (
    <>
      {MENUS.map((menu, index) => {
        return (
          <React.Fragment key={index}>
            <SidebarList
              subheaderText={menu.subheader}
              items={menu.items}
              path={menu.path}
              expand={index === indexExpand}
              onSubHeaderClick={() =>
                setIndexExpand(index === indexExpand ? -1 : index)
              }
            />
            {index < MENUS.length - 1 && (
              <Box sx={{ px: 2 }}>
                <Divider />
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default SidebarWide;
